import request from 'superagent';
import superagentPromisePlugin from 'superagent-promise-plugin';
import config from '../config/config';

function login(query) {

    // console.debug("Query: " + Object.keys(query));
    // console.debug("Config: " + Object.keys(config));
    // console.debug("POST: " + `${config.apiUrl}/login`);
    return request.post(`${config.apiUrl}/login`)
    .withCredentials()
    .use(superagentPromisePlugin)
    .set('X-STORE-CODE', query.store_id)
    .send(`user=${query.user}`)
    .send(`store_id=${query.store_id}`)
    .send(`ts=${query.tS}`)
    .send(`md5=${query.md5}`)
    .catch(err => {
        // FIXME improve differentiation between different error cases (err.response.status)
        console.error(err);
        throw err;
    });
}

export default login;



// WEBPACK FOOTER //
// ./src/script/auth.js